// extracted by mini-css-extract-plugin
export default {"controls":"controls--iXeJN","buttons":"buttons--GVgIk","btn":"btn--cnhGC","addBtn":"addBtn--U3u5M"};